module.exports = require('./flowRight');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/compose.js
// module id = 1278
// module chunks = 0